import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "tabbar",
  role: "navigation",
  "aria-label": "Primary mobile navigation"
};
const _hoisted_2 = {
  class: "tabbar__label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("nav", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, item => {
    return _openBlock(), _createBlock(_component_router_link, {
      key: item.key,
      to: item.to,
      class: _normalizeClass(["tabbar__item", {
        'is-active': $props.active === item.key
      }])
    }, {
      default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
        size: 22,
        weight: $props.active === item.key ? 'fill' : 'regular',
        "aria-hidden": "true"
      }, null, 8, ["weight"])), _createElementVNode("span", _hoisted_2, _toDisplayString(item.label), 1)]),
      _: 2
    }, 1032, ["to", "class"]);
  }), 128))]);
}